<template>
  <div class="header bg-white shadow-md flex items-center justify-between px-4 py-2">
    <div class="flex items-center space-x-2">
      <img src="@/assets/logo.png" alt="Logo" class="w-8 h-8" />
      <span class="font-bold text-xl text-gray-800">Puls</span>
    </div>

    <div class="flex items-center space-x-4">
      <div class="flex space-x-4">
      </div>

      <div class="relative" @click="toggleDropdown">
        <div class="flex items-center space-x-2 cursor-pointer">
  <img src="@/assets/patient.png" alt="User Profile" class="w-8 h-8 rounded-full" />
  <div>
    <p class="text-gray-800 font-semibold">{{ userName }}</p>
    <p class="text-gray-500 text-sm">{{ userRole }}</p>
  </div>
  <i class="fas fa-chevron-down text-gray-600"></i>
</div>

        <!-- Dropdown Menu -->
        <div v-if="isDropdownOpen" class="absolute right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg z-10">
          <a href="#" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">My Profile</a>
          <a href="#" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">My Contacts</a>
          <a href="#" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">Account Settings</a>
          <hr class="my-1">
          <a href="#" @click.prevent="logout" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">Log Out</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userInfo } from "@/services/userService";

export default {
  name: "TopNavbar",
  data() {
    return {
      isDropdownOpen: false,
      userName: "",
      userRole: "",
    };
  },
  async created() {
    try {
      const response = await userInfo();
      const user = response.data;
      this.userName = `${user.full_name} ${user.last_name}`;
      this.userRole = user.role;
    } catch (error) {
      console.error("Ошибка при получении данных пользователя:", error);
    }
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.push({ name: "Login" });
    }
  }
};
</script>

<style scoped>
.header {
  height: 60px;
}
</style>
